/**
 * Event tracking constants for the Managed Repeats page
 * Organized by sections: Active DMR, Create DMR, Add Patient
 */

const FEATURE_CLICKED = 'feature_clicked' as const;
const SECTION_CLICKED = 'section_clicked' as const;
const TAB = 'managed_repeats' as const;

/**
 * All managed repeats page events
 */
export const MANAGED_REPEATS_EVENTS = {
  // Tutorial/Guide actions in header
  VIEW_GUIDE_CLICKED: {
    action: 'view_guide_clicked',
    type: FEATURE_CLICKED,
    tab: TAB,
  },
  WATCH_TUTORIAL_CLICKED: {
    action: 'watch_tutorial_clicked',
    type: FEATURE_CLICKED,
    tab: TAB,
  },

  // Active DMR Section
  ACTIVE_DMR: {
    SECTION_CLICKED: {
      action: 'section_clicked',
      type: SECTION_CLICKED,
      tab: TAB,
      section: 'active_dmr',
    },
    FILTER_SELECTED: {
      action: 'filter_selected',
      type: FEATURE_CLICKED,
      tab: TAB,
      section: 'active_dmr',
    },
    SEARCHED: {
      action: 'searched',
      type: FEATURE_CLICKED,
      tab: TAB,
      section: 'active_dmr',
    },
    APPROVED: {
      action: 'approved',
      type: FEATURE_CLICKED,
      tab: TAB,
      section: 'active_dmr',
    },
    SCHEDULE_UPDATED: {
      action: 'schedule_updated',
      type: FEATURE_CLICKED,
      tab: TAB,
      section: 'active_dmr',
    },
    SCHEDULE_DELETED: {
      action: 'schedule_deleted',
      type: FEATURE_CLICKED,
      tab: TAB,
      section: 'active_dmr',
    },
  },

  // Create DMR Section
  CREATE_DMR: {
    SECTION_CLICKED: {
      action: 'section_clicked',
      type: SECTION_CLICKED,
      tab: TAB,
      section: 'create_dmr',
    },
    SEARCHED: {
      action: 'searched',
      type: FEATURE_CLICKED,
      tab: TAB,
      section: 'create_dmr',
    },
    CREATED: {
      action: 'created',
      type: FEATURE_CLICKED,
      tab: TAB,
      section: 'create_dmr',
    },
    PATIENT_UNASSIGNED: {
      action: 'patient_unassigned',
      type: FEATURE_CLICKED,
      tab: TAB,
      section: 'create_dmr',
    },
  },

  // Add Patient Section
  ADD_PATIENT: {
    SECTION_CLICKED: {
      action: 'section_clicked',
      type: SECTION_CLICKED,
      tab: TAB,
      section: 'add_patient',
    },
    FILTER_SELECTED: {
      action: 'filter_selected',
      type: FEATURE_CLICKED,
      tab: TAB,
      section: 'add_patient',
    },
    SEARCHED: {
      action: 'searched',
      type: FEATURE_CLICKED,
      tab: TAB,
      section: 'add_patient',
    },
    PATIENT_ADDED: {
      action: 'patient_added',
      type: FEATURE_CLICKED,
      tab: TAB,
      section: 'add_patient',
    },
    PATIENT_ADDED_IN_BATCH: {
      action: 'patient_added_in_batch',
      type: FEATURE_CLICKED,
      tab: TAB,
      section: 'add_patient',
    },
  },
} as const;

